import { render, staticRenderFns } from "./wordM5.vue?vue&type=template&id=304f4dbc&scoped=true&"
import script from "./wordM5.vue?vue&type=script&lang=js&"
export * from "./wordM5.vue?vue&type=script&lang=js&"
import style0 from "./wordM5.vue?vue&type=style&index=0&id=304f4dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f4dbc",
  null
  
)

export default component.exports